var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHrAnnouncement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 50,
    fill: "#FFFBF1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.9993 59.9993C48.2227 60.8292 45.8888 61.3327 43.3327 61.3327C41.9115 61.3327 40.5589 61.1771 39.3327 60.8961C37.2237 60.4131 36.666 59.1721 36.666 57.1807V42.818C36.666 41.5049 38.0527 40.603 39.3327 40.8961C40.5589 41.177 41.9115 41.3327 43.3327 41.3327C45.8888 41.3327 48.2227 40.8292 49.9993 39.9993C51.776 39.1695 54.1099 38.666 56.666 38.666C58.0872 38.666 59.4397 38.8217 60.666 39.1025C62.7749 39.5856 63.3327 40.8265 63.3327 42.818V57.1807C63.3327 58.4939 61.946 59.3957 60.666 59.1025C59.4397 58.8216 58.0872 58.666 56.666 58.666C54.1099 58.666 51.776 59.1695 49.9993 59.9993Z",
    stroke: "#FFCE48",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3327 49.9993C53.3327 51.8403 51.8403 53.3327 49.9993 53.3327C48.1584 53.3327 46.666 51.8403 46.666 49.9993C46.666 48.1584 48.1584 46.666 49.9993 46.666C51.8403 46.666 53.3327 48.1584 53.3327 49.9993Z",
    stroke: "#FFCE48",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.334 51.334V51.346",
    stroke: "#FFCE48",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M58.666 48.6562V48.6683",
    stroke: "#FFCE48",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHrAnnouncement);
export default __webpack_public_path__ + "static/media/hr-announcement.fa1cfa20e7898be8dfeec832f359dc0e.svg";
export { ForwardRef as ReactComponent };